import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { TableFormComponent } from '../table-form/table-form.component';
import { LinkFormComponent } from '../link-form/link-form.component';

@Component({
  selector: 'dbm-tool',
  standalone: true,
  imports: [NgClass, TableFormComponent, LinkFormComponent],
  templateUrl: './dbm-tool.component.html',
  styleUrl: './dbm-tool.component.scss',
})
export class DbmToolComponent {
  isCollapsed: boolean = true;
  choice: string = 'table';

  toggleisCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  select(choice: string): void {
    this.choice = choice;
  }
}
